//Importing main SCSS file.
import "../assets/scss/main.scss";

//Modules and classes

//Instantiate new object using modules and classes

//Test script
